import InteractiveMapControl from './interactive-map-control'

export default InteractiveMapControl
